import classNames from 'classnames'
import Link, { LinkProps } from 'next/link'
import { ContainerElement } from 'types'

const sizes = {
  sm: 'text-sm py-1.5 px-2',
  custom: '',
} as const

interface Props extends LinkProps, ContainerElement {
  size?: keyof typeof sizes
}

export function NavItem({ children, className, size = 'sm', ...props }: Props) {
  return (
    <Link
      {...props}
      className={classNames(
        className,
        sizes[size],
        'flex items-center space-x-2 transition-colors duration-150 hover:bg-primary-light/70'
      )}
    >
      {children}
    </Link>
  )
}
